import { Component, OnInit } from '@angular/core';
import { colors } from 'app/colors.const';

@Component({
  selector: 'app-key-initiatives',
  templateUrl: './key-initiatives.component.html',
  styleUrls: ['./key-initiatives.component.scss']
})
export class KeyInitiativesComponent implements OnInit {

  ourProjectsFirst:boolean;
  ourProjectsTow:boolean;
  ourProjectsThree:boolean;
  ourProjectsFour:boolean;
  ourProjectsFive:boolean;
  ourProjectsSix:boolean;

  public contentHeader;
  constructor() { }

  ngOnInit(): void {
    this.contentHeader = {
      headerTitle: 'Key Initiatives',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Key Initiatives',
            isLink: true,
            link: '/key-initiatives'
          },
          // {
          //   name: 'eCommerce',
          //   isLink: true,
          //   link: '/'
          // },
          // {
          //   name: 'Shop',
          //   isLink: true,
          //   link: '/'
          // },
          // {
          //   name: 'Details',
          //   isLink: false
          // }
        ]
      }
    };
    this.onOurProjectsFirst();
  }
  onOurProjectsFirst(){
    this.ourProjectsFirst = true;
    this.ourProjectsTow = false;
    this.ourProjectsThree =false;
    this.ourProjectsFour = false;
    this.ourProjectsFive = false;
    this.ourProjectsSix = false;
  }
  onOurProjectsTow(){
    this.ourProjectsFirst = false;
    this.ourProjectsTow = true;
    this.ourProjectsThree =false;
    this.ourProjectsFour = false;
    this.ourProjectsFive = false;
    this.ourProjectsSix = false;

  }
  onOurProjectsThree(){
    this.ourProjectsFirst = false;
    this.ourProjectsTow = false;
    this.ourProjectsThree =true;
    this.ourProjectsFour = false;
    this.ourProjectsFive = false;
    this.ourProjectsSix = false;
  }
  onOurProjectsFour(){
    this.ourProjectsFirst = false;
    this.ourProjectsTow = false;
    this.ourProjectsThree =false;
    this.ourProjectsFour = true;
    this.ourProjectsFive = false;
    this.ourProjectsSix = false;
  }
  onOurProjectsFive(){
    this.ourProjectsFirst = false;
    this.ourProjectsTow = false;
    this.ourProjectsThree =false;
    this.ourProjectsFour = false;
    this.ourProjectsFive = true;
    this.ourProjectsSix = false;
  }
  onOurProjectsSix(){
    this.ourProjectsFirst = false;
    this.ourProjectsTow = false;
    this.ourProjectsThree =false;
    this.ourProjectsFour = false;
    this.ourProjectsFive = false;
    this.ourProjectsSix = true;
  }


}
